import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import ScrollToTop from '../ScrollToTop';
import RouteChangeTracker from '../RouteChangeTracker';
import { useHomepageContent } from '../../hooks/useHomepageContent';
import './index.module.css';

const Layout = () => {
  const { header, banner, footer } = useHomepageContent();
  return (
    <div id="wrapper">
      <Header content={header} banner={banner} />
      <main>
        <ScrollToTop />
        <RouteChangeTracker />
        <Outlet />
      </main>
      <Footer content={footer} />
    </div>
  );
};

export default Layout;
